export default __webpack_public_path__ + "static/aws_logo-42796768b6ebc37bb55cb9cdc511e097.jpg";